import React from "react";
import { motion } from "framer-motion";
import { User, Building, Crown } from "lucide-react";
import AccountTypeCard from "./AccountBenefitsSection/AccountTypeCard";
import ProcessSection from "./AccountBenefitsSection/ProcessSection";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AccountBenefitsSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.buyCar?.accountBenefitsSection || {};
  const accountTypesData = sectionData.accountTypes || [];

  const icons = [
    <User className="w-8 h-8" />,
    <Building className="w-8 h-8" />,
    <Crown className="w-8 h-8" />,
  ];
  const colors = [
    "from-blue-500 to-cyan-500",
    "from-green-500 to-emerald-500",
    "from-purple-500 to-pink-500",
  ];

  const accountTypes = accountTypesData.map((account: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: account.title || "",
    description: account.description || "",
    benefits: account.benefits || [],
    color: colors[index] || colors[0],
  }));

  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-12 max-w-3xl mx-auto"
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            {sectionData.title || "Skapa Konto & Få Exklusiva Fördelar"}
          </h2>
          <p className="text-base md:text-lg text-gray-600 px-4">
            {sectionData.description ||
              "Som privat, företag eller handlare får du olika fördelar."}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12 max-w-6xl mx-auto">
          {accountTypes.map((account, index) => (
            <AccountTypeCard key={index} account={account} index={index} />
          ))}
        </div>

        <ProcessSection />
      </div>
    </section>
  );
};

export default AccountBenefitsSection;
